import { legacy_createStore as createStore, Store } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { profileReducer, ProfileState } from "./profile-data.slice";

export interface StoreInterface {
  profile: ProfileState;
}

const reducer = combineReducers({
  profile: profileReducer.reducer,
});

export const store: Store<StoreInterface> = createStore(reducer);
